export class AccountModel
{
    id = '';
    userId = '';
    userName = '';
    password = '';
    createdDate: null | string = null;
    modifiedDate: null | string = null;
    createdBy = '';
    modifiedBy = '';
    oldPassword = '';
    roleId = 'user';
    status: boolean | number = 1;
    courseId = '';
}

export class AccountUserModel extends AccountModel
{
    name = '';
    email = '';
    address = '';
    phone = '';
    identityNo = '';
    className = '';
    birthday: any = null;
    avatar = '';
    roleName = '';
    roleDescription = '';

    roleTypeDataId = 'user';
    roleTypeDataName = '';
    memberIds = '';
    isActive? = false;
}

export class UserInfoModel {
    id = '';
    name = '';
    email = '';
    address = '';
    phone = '';
    identityNo = '';
    status: boolean | number = 1;
    className = '';
    birthday: any = null;
    avatar = '';
    createdDate: any = null;
    createdBy = '';
    modifiedDate: any = null;
    modifiedBy = '';
}

export class AccountLoginModel
{
    id = '';
    firstName = '';
    lastName = '';
    username = '';
    password? = '';
    refreshTokens?: any = [];
}

export class UserRoles {
    role_id = '';
    role_name = '';
    account_id = '';
}
export class AccountLoginResponseModel {
    avatar = '';
    email = '';
    id = '';
    phone = '';
    refreshToken = '';
    token ='';
    username = '';
    userId = '';
    address = '';
    name = '';
    birthday = '';
    roles: string | UserRoles[] = '';
    roleId = '';
    roleName = '';
    identityNo = '';
}

export class AccountChangePasswordModel {
    oldPassword = '';
    newPassword = '';
    userName = '';
}

export class UpdateAccountInfoModel {
    userName = '';
    name = '';
    phone = '';
    email = '';
    identityNo = '';
}

export class AccountSelect {
    id = '';
    name = '';
    phone = '';
}

export class LoginDataModel {
    address = '';
    avatar = '';
    birthday: any = '';
    email = '';
    id = '';
    identityNo = '';
    name = '';
    phone = '';
    refreshToken = '';
    roles: {role_id: string; role_name: string; account_id: string; }[] = [];
    token = '';
    userId = '';
    username = '';
}